import { render, staticRenderFns } from "./Segmentos.vue?vue&type=template&id=577e2a61"
import script from "./Segmentos.vue?vue&type=script&lang=js"
export * from "./Segmentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports